module.exports = __webpack_public_path__ + "img/xinyong.ae03ea1d.png";